<template>
    <div v-if="loading" id="loading">
      <span><i class="fas fa-spinner fa-pulse"></i>   Carregando...</span>
    </div>
    <div v-else>
      <div v-if="chartData[0] && chartData[0].data?.length > 0">
        <apexchart
          :options="chartOptions"
          :series="chartData"
          type="bar"
        />
      </div>
      <div v-else id="no-records">
        <span><i class="fas fa-circle-xmark"></i>   Não há registros para gerar gráfico</span>
      </div>
    </div>
</template>
  
  <script>
  export default {
    props: ['bankNpsData', 'period'],
    data(){
      return {
        chartData: [],
        bankNpsList: [],
        bankNpsArray: [],
        sortedBankNps: [],
        loading: false
      }
    },
    mounted(){
    },
    watch: {
      async bankNpsData() {
        this.chartData = [];
        if(Object.entries(this.bankNpsData).length > 0){
          this.loading = true;
          await this.generateChart();
          await this.fillerGenerator();
          await this.nameFormatter();
          this.loading = false;
        } 
      }
    },
    methods: {
      async generateChart(){
        this.chartData = [];
        this.sortedBankNps = [];
        this.bankNpsList = Object.keys(this.bankNpsData);
        this.bankNpsArray = [];

        Object.entries(this.bankNpsData).forEach((el, index) => {
          Object.entries(el[1]).forEach((grade, i) => {
            if(grade[0] !== 'nps' && grade[0] !== 'total' && grade[0] !== 'naoavaliado' && index === 0) {
              this.chartData.push({data: [], name: grade[0]});
            }
          })
        })

        
        this.sortedBankNps = Object.entries(this.bankNpsData).sort((a, b) => {
          if(a[1].total < b[1].total) return 1;
          if(b[1].total < a[1].total) return -1;
          if(a[1].total == b[1].total) return;
        })
        
        this.sortedBankNps.forEach(bank => {
          Object.entries(bank[1]).forEach((el) => {
            const foundElement = this.chartData.find(element => element.name === el[0]);
            if(foundElement) {
              const elementIndex = this.chartData.indexOf(foundElement);
              this.chartData[elementIndex].data.push(el[1]);
            }
          })
        })
        return;
      },
      async nameFormatter(){
        this.chartData.forEach(el => {
          if(el.name == 'otimo'){
            el.name = "😄 Ótimo";
          } else if(el.name == 'bom'){
            el.name = "🙂 Bom"
          } else if(el.name == 'regular'){
            el.name = "😐 Regular"
          } else if(el.name == 'ruim'){
            el.name = "🙁 Ruim"
          } else if(el.name == 'pessimo'){
            el.name = "😩 Péssimo"
          } else if (el.name == 'naoavaliado')
          el.name = "Não avaliado";
        })
      },
      async fillerGenerator(){
          return this.colorArray = [
            // '#d3d3d3',
            '#e34a4a', 
            '#e37979',
            '#b78915',
            '#90ee90',
            '#22a722'
          ];
      }
    },
    computed: {
      chartOptions() {
        return {
          title: {
            text: 'NPS por Instituição Financeira',
          },
          chart: {
            id: "nps_instituicao_financeira",
            toolbar: {
              show: true,
              export: {
              },
            },
            type: 'bar',
            stacked: true,
            stackType: '100%'
          },
          colors: this.colorArray,
          plotOptions: {
            bar: {
              horizontal: true,
              columnsWidth: 50,
            },
          },
          dataLabels: {
            style: {
              fontWeight: 'bolder',
              colors: ['#FFF']
            },
            background: {
              enabled: true,
              foreColor: '#000',
              padding: 1,
              borderRadius: 5,
              borderWidth: 1,
              borderColor: '#fff',
              opacity: 0.8,
              dropShadow: {
                enabled: false,
                top: 1,
                left: 1,
                blur: 1,
                color: '#000',
                opacity: 0.65
              }
            },
          },
          legend: {},
          stroke: {
            show: true,
            width: 1,
            colors: ['#fff']
          },
          xaxis: {
            categories: this.chartCategories,
            labels: {
              show: false
            },
            // tickAmount: 5
          },
          tooltip: {
            theme: 'dark',
            y: {
              formatter: function (value) {
                return Math.floor(value); // Exibe apenas a parte inteira do valor
              }
            }
          },
          yaxis: {
            show: true,
            labels: {
              formatter: function(val) {
                return val.toString(); // Formate o valor conforme necessário
              }
            }
          },
        };
      },
      chartCategories() {
        let categories = []
        this.sortedBankNps.forEach(el => {
          categories.push(el[0])
        })
        return categories;
      },
    },
  }
  </script>
  
  <style scoped>
    #chart-area{
      background-color: white;
    }
    #no-records {
      height: 90%;
      display: flex;
      justify-content: center;
    }
  
    #no-records span{
        align-self: center;
        font-size: x-large;
        font-weight: bold;
        color: #1c869a;
    }
  
    #no-records span i{
        color: red;
    }

    #loading {
      height: 90%;
      display: flex;
      justify-content: center;
    }
  
    #loading span{
      align-self: center;
      font-size: x-large;
      font-weight: bold;
      color: #1c869a;
    }
  </style>